<template>
  <div class="account-verification__container">
    <account-verification-modal
        :is-dialog-visible="isAccountVerificationModalVisible"
        :is-verification-override="false"
        @visibilityChanged="setIsAccountVerificationModalVisible" />

    <div class="heading__small-medium title">
      Account Verification Required
    </div>
    <div class="message">
      To see schedules for {{ deviceName }}, please verify this account.
    </div>
    <el-button
        class="button"
        type="primary"
        @click="verifyAccount()">
      Verify Account
    </el-button>
  </div>
</template>

<script>
import AccountVerificationModal from "@/NewUI/components/customer/authorizations/shared/AccountVerificationModal.vue";
import { createNamespacedHelpers as module } from "vuex";
import permission from "@/mixins/permission";

const { mapGetters: accountGetters } = module("db/account");

export default {
  name: "AccountVerificationMessage",
  components: {
    AccountVerificationModal,
  },
  mixins: [permission],
  props: {
    deviceName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isAccountVerificationModalVisible: false,
    };
  },
  computed: {
    ...accountGetters(["customerId"]),
  },
  methods: {
    verifyAccount() {
      this.setIsAccountVerificationModalVisible(true);
    },
    setIsAccountVerificationModalVisible(value) {
      this.isAccountVerificationModalVisible = value;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/newui/fonts.scss";

.message {
  @include body__large-regular;
  margin-top: 11px;
}

.account-verification__container {
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.button {
  @include body__normal-regular;
  color: white;
  margin-top: 20px;
}
</style>
